import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  template: `
    <h2 mat-dialog-title>
      {{ 'ACTION_LISTS.ACTION_LISTS_ACCOUNTS.ARE_YOU_SURE_YOU_WANT_TO_REMOVE' | translate : { name: name } }}
    </h2>
    <mat-dialog-content>
      <p>
        {{ 'ACTION_LISTS.ACTION_LISTS_ACCOUNTS.REMOVING_AN_ACCOUNT' | translate }}
      </p>
      <div></div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button matDialogClose>{{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}</button>
      <button mat-raised-button color="primary" (click)="removeAccount()">
        {{ 'COMMON.ACTION_LABELS.REMOVE' | translate }}
      </button>
    </mat-dialog-actions>
  `,
})
export class RemoveAccountDialogComponent {
  public name: string;
  @Output() removed: EventEmitter<boolean> = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { name: string },
    private dialogRef: MatDialogRef<RemoveAccountDialogComponent>,
  ) {
    this.name = data.name;
  }

  removeAccount(): void {
    this.removed.emit(true);
    this.dialogRef.close();
  }
}
